/* eslint-disable */
import store from '@/store'
import apiAIT from '@/common/ateneaInvoiceToolsApi'

export default {
  name: 'form-sagepayments',
  data: () => {
    return {
      user: store.getters.getUser,
      title: 'Pagos Sage',
    }
  },

  created() {
  },
  computed: {
  },
  methods: {
    
  }
}
